import cls from "./customInnerPage.module.scss";
import {useDispatch, useSelector} from "react-redux";
import React, {Dispatch, SetStateAction, useEffect, useRef, useState} from "react";
import {AddCartToken} from "../../../store/token";
import {setCrossValid, setPopupName, setTempData} from "../../../store/general";
import {cartAddItem, getUpOrCrossProd} from "../../../store/cart";
import {ICurrencies} from "../Wrappers/MainLayout";
import {IAttributeInner, IProduct, optionItemType} from "../../../types/homePageTypes";
import {domainUrl} from "../../../helper";
import {addToCartEventPixel} from "../../shared/ProductCard/helpers";
import {IState} from "../../../types/state";
import {formatPrice} from "../../../controllers/helpers";

export const showBoxAboutDetails: Record<string, { display: "block" | "none", className: string }> = {
    "true": {
        display: "block",
        className: "",
    },
    "false": {
        className: "only_one",
        display: "none"
    }
}

export const isSelectedDetailSectionClass = (description: React.JSX.Element, detail: React.JSX.Element): Record <"true" | "false", {
    first: string,
    second: string,
    content: React.JSX.Element
}> => {
    return {
        "true": {
            first: `${cls["tab"]} ${cls["tab_description"]}`,
            second: `${cls["tab"]} ${cls["tab_detail"]} ${cls["tab_detail-active"]}`,
            // display: "none"
            content: detail
        },
        "false": {
            first: `${cls["tab"]} ${cls["tab_description"]} ${cls["tab_description-active"]}`,
            second: `${cls["tab"]} ${cls["tab_detail"]}`,
            // display: "block"
            content: description
        }
    }
}

export const dangerOrSuccessStyleConfig = {
    "true": {
        "true": {
            className: "text-success",
            IntlKey: "ChooseOption",
        },
        "false": {
            className: "text-success",
            IntlKey: "InStock",
        },
    },
    "false": {
        "true": {
            className: "",
            IntlKey: "ChooseOption",
        },
        "false": {
            className: "text-danger",
            IntlKey: "OutOfStock",
        },
    }
}

export const dangerOrSuccessStyleSimple = {
    "true": {
        className: "text-success",
        ItlKey: "InStock",
    },
    "false": {
        className: "text-danger",
        ItlKey: "OutOfStock",
    }
}

export const addCartDivStyleToggleConfig: Record<string, Record<string, string>> = {
    "true": {
        "true": "button_disabled",
        "false": ""
    },
    "false": {
        "true": "button_disabled",
        "false": ""
    }
}

export const addCartDivStyleToggleSimple: Record<string, string> = {
    "true": "",
    "false": "button_disabled"
}

export const openedBoxStyles = {
    "true": {
        arrowClass: "drop_down_opened",
        display: "block"
    },
    "false": {
        arrowClass: "",
        display: "none"
    }
}

export const concatFilters: Record<string, Record<string, string>> = {
    "false": {
        mainDivClass: "attr_fms",
        childDivClass: "other-list-main-fms"
    },
    "true": {
        mainDivClass: "attr_color_fms",
        childDivClass: "color-attr_fm"
    }
}

export const swatchTypeHandlerClass = {
    "true": {
        "true": "input-check-color--white",
        "false": "input-check-color--white"
    },
    "false": {
        "true": "input-check-color--light",
        "false": ""
    }
}

export const useFetchCartToken = (cartToken: { cartToken: string }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchCartData = {
            "false": () => {
                fetch("/api/checkout/cart/token")
                    .then((response) => response.json())
                    .then((res) => {
                        if (res.api_token) {
                            dispatch(AddCartToken(res.api_token));
                        }
                    })
                    .catch((err) => console.error(err))
            },
            "true": () => {
            }
        };

        fetchCartData[`${!!cartToken.cartToken}`]();
    }, []);
};


const upCrossSellHandle: (
    attr: {
        dispatch: Dispatch<any>,
        productId: number;
        selectedLocale: string;
        selectedRate: ICurrencies;
        product: IProduct
    }
) => Record<string, Record<string, () => void>> = (attr) => {
    const {
        dispatch,
        productId,
        selectedLocale,
        selectedRate,
        product
    } = attr;
    return {
        "true": {
            "true": () => {
                dispatch(setPopupName("upsell"));
                dispatch(getUpOrCrossProd(
                    productId,
                    'up-sell',
                    selectedLocale,
                    selectedRate
                ))
                dispatch(setTempData([product]))
            },
            "false": () => upCrossSellHandle(attr)["true"]["true"](),
        },
        "false": {
            "true": () => {
                dispatch(getUpOrCrossProd(
                    productId,
                    'cross-sell',
                    selectedLocale,
                    selectedRate
                ))
                dispatch(setCrossValid(true));
                dispatch(setPopupName("crossSell"));
                dispatch(setTempData([product]))
            },
            "false": () => {
            }
        }
    }
}
export const openUpCrossProd = (attr: {
    has_up_sell: number,
    has_cross_sell: number,
    dispatch: Dispatch<any>,
    productId: number,
    selectedLocale: string,
    selectedRate: ICurrencies,
    product: IProduct,
}) => {
    const {has_up_sell, has_cross_sell, ...crossAttributes} = attr
    return upCrossSellHandle(crossAttributes)[`${!!parseFloat(String(has_up_sell))}`][`${!!parseFloat(String(has_cross_sell))}`]()
}

export const handleCardClick: (attr: {
    has_up_sell: number,
    has_cross_sell: number,
    dispatch: Dispatch<any>,
    productId: number,
    selectedLocale: string,
    selectedRate: ICurrencies,
    product: IProduct,
    cartToken: { cartToken: string },
    customerToken: string,
    addToast(error?: boolean): void;
    quantity?: number;
    links: Array<number>
}) => Record<string, Record<string, Record<string, () => void>>> = (attr) => {
    const {
        dispatch,
        product,
        cartToken,
        customerToken,
        selectedLocale,
        selectedRate,
        addToast,
        quantity = 1,
        links,
        ...otherProps
    } = attr;

    return {
        "true": {
            "true": {
                "true": () => {
                    openUpCrossProd({dispatch, selectedRate, selectedLocale, product, ...otherProps})
                },
                "false": () => {
                    openUpCrossProd({dispatch, selectedRate, selectedLocale, product, ...otherProps})
                }
            },
            "false": {
                "true": () => {
                    openUpCrossProd({dispatch, selectedRate, selectedLocale, product, ...otherProps})
                    addToCartEventPixel(product, quantity, selectedRate);
                    dispatch(cartAddItem(
                        product,
                        quantity,
                        cartToken,
                        {token: customerToken} as { token: string },
                        selectedLocale,
                        selectedRate.symbol,
                        null,
                        addToast,
                        links
                    ));
                },
                "false": () => {
                    addToCartEventPixel(product, quantity, selectedRate);
                    dispatch(cartAddItem(
                        product,
                        quantity,
                        cartToken,
                        {token: customerToken} as { token: string },
                        selectedLocale,
                        selectedRate.symbol,
                        null,
                        addToast,
                        links
                    ));
                }
            }
        },
        "false": {
            "true": {
                "true": () => {},
                "false": () => {}
            },
            "false": {
                "true": () => {},
                "false": () => {}
            }
        }
    }
}

export const schemaProduct = (
    asPath: string,
    productName: string,
    productDesc: string,
    productImgPath: string,
    productSku: string,
    productId: number,
    dbName: string,
    domain: string,
    schemaBrandName: string
) => {
    return {
        "@context": `https://schema.org/`,
        "@type": "Product",
        "name": productName,
        "description": productDesc,
        "image": domainUrl(`${dbName}${productImgPath}`),
        "url": domainUrl(`${dbName}${asPath}`),
        "brand": {
            "@type": "Brand",
            "name": schemaBrandName,
        },
        "review": {
            "@type": "Review",
            "name": "Organization Review",
            "reviewRating": {
                "@type": "Rating",
                "ratingValue": "0"
            },
            "author": {
                "@type": "Organization",
                "name": domain
            },
        },
        "productID": productId,
        "sku": productSku,
    };
}

export const formatOptionQuantityObj = (concatCurrElem: optionItemType[], item: optionItemType) => {
    const minimumDefaultQty = Math.min(...concatCurrElem.map(elem => +elem.optionDefaultQty))
    const minimumProductQty = Math.min(...concatCurrElem.map(elem => +elem.productQty))
    const totalPrice = concatCurrElem.reduce((total, {price}) => {
        return total + price;
    }, 0);
    return {
        ...item,
        id: concatCurrElem.map(el => el.id).flat(),
        productQty: minimumProductQty,
        optionDefaultQty: minimumDefaultQty,
        bundleOptionId: concatCurrElem[0].bundleOptionId,
        price: totalPrice
    }
}

export const handleChangeOutsideForMulti = (
    e: { target: HTMLInputElement } | {target: { value: string, id: number }},
    optionQuantity: Array<optionItemType>,
    setOptionQuantity: Dispatch<SetStateAction<optionItemType[]>>
) => {
    const value = JSON.parse(e.target.value);
    const existThisVal = optionQuantity.find(option => {
        if (Array.isArray(option?.id)) {
            return option.id.some(elem => String(elem) === String(e.target.id))
        } else {
            return String(option?.id) === e.target.id
        }
    });
    if (existThisVal) {
        if (Array.isArray(existThisVal.id)) {
            if (existThisVal.id.length === 1) {
                setOptionQuantity((prevState) => prevState.filter(element => {
                    if (Array.isArray(element.id)) {
                        return String(element.id[0]) !== e.target.id
                    }
                    return String(element.id) !== e.target.id
                }))
            } else {
                setOptionQuantity(prevState => {
                    return prevState.map(elem => {
                        if (Array.isArray(elem.id)) {
                            return {
                                ...elem,
                                id: elem.id.filter(lll => String(lll) !== e.target.id),
                                price: elem.price - value.price
                            }
                        }
                        return elem
                    })
                })
            }
        }
        setOptionQuantity(prevState => prevState.filter(lll => String(lll.id) !== e.target.id))
    } else {
        setOptionQuantity((prevState) => {
            const currElement = prevState.filter(element => element.bundleOptionId === value.bundleOptionId)
            if (currElement.length > 0) {
                const concatCurrElem = [...currElement, value]
                return prevState.map(item => {
                    if (currElement.find(it => item.id === it.id)) {
                        return formatOptionQuantityObj(concatCurrElem, item)
                    }
                    return item
                })
            }
            return [...prevState, value]
        })
    }
}

export const useCustomOptions = (
    {
        setClientSideProduct,
        productMinPrice,
        productSpecialPrice,
        productPrice,
        selectedRate,
        asPath,
        product,
        productSlug
    }: {
        setClientSideProduct: Dispatch<SetStateAction<IProduct>>,
        productMinPrice: string | null,
        productSpecialPrice: string | null,
        productPrice: string | null,
        selectedRate: ICurrencies,
        asPath: string,
        product?: IProduct
        productSlug: string
    }
)=> {
    const optionValues = useSelector(((state: IState) => state.product.optionValues));
    const refsMap = useRef<Map<number, HTMLDivElement>>(new Map());
    const customOptions = {
        "customizable_options": optionValues.reduce((result: Record<string, number>, value) => {
            result[`${value.id}`] = value.optionId;
            return result;
        }, {}),
    };
    const handleAmdPrice = ({ code: currCode }: ICurrencies, price: number) => {
        const currentCurrCodeIsAmdOrRub = currCode.toLowerCase() === "amd" || currCode.toLowerCase() === "rub";
        if (!currentCurrCodeIsAmdOrRub) {
            return Number(price).toFixed(2)
        }
        return +price
    }

    useEffect(() => {
        const priceArray = optionValues.map((element) => {
            if (product?.attribute_family?.code === "Donation") {
                return parseFloat(element.label)
            }
            return parseFloat(element.price)
        });
        const concatenatedString = priceArray.reduce(
            (accumulator, currentValue) => accumulator + currentValue, 0
        ).toString() + '.000';
        setClientSideProduct((prev: IProduct) => {
            const newProductFlat = {...prev.flats[0]};
            const defaultMinPrice = productMinPrice ? parseFloat(productMinPrice) : 0;
            const defaultSpecialPrice = productSpecialPrice ? parseFloat(productSpecialPrice) : 0;
            const defaultPrice = productPrice ? parseFloat(productPrice) : 0;
            const newPrice = defaultPrice + parseFloat(concatenatedString) || 0;
            newProductFlat.price = formatPrice(newPrice, selectedRate).replace(/\B(?=(\d{3})+(?!\d))/g, ",");;
            const newFlatPriceHandle = {
                minToggle: {
                    "true": () => {
                        const newMinPrice = defaultMinPrice + parseFloat(concatenatedString) || 0;
                        newProductFlat.min_price = formatPrice(newMinPrice, selectedRate).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    },
                    "false": () => {
                    },
                },
                specialToggle: {
                    "true": () => {
                        const newSpecialPrice = defaultSpecialPrice + parseFloat(concatenatedString) || 0;
                        newProductFlat.special_price = formatPrice(newSpecialPrice, selectedRate).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    },
                    "false": () => {
                    }
                }
            }
            newFlatPriceHandle.minToggle[`${productMinPrice !== null}`]();
            newFlatPriceHandle.specialToggle[`${!!productSpecialPrice}`]();

            return {
                ...prev,
                flats: [newProductFlat],
            };
        })
        localStorage.setItem("customOptions", JSON.stringify(customOptions))
    }, [optionValues, asPath, productSlug])

    return {customOptions, refsMap};
}

export const configInActiveVariantHelper = (
    {
        setConfigAttributesCSR,
        configAttributesCSR,
        configVariants,
        configAttributes,
        updatedFiltered
    }: {
        setConfigAttributesCSR: Dispatch<SetStateAction<IAttributeInner[]>>
        configAttributesCSR: IAttributeInner[],
        configVariants: any[],
        configAttributes: IAttributeInner[],
        updatedFiltered: Record<string, string | number>
    }
) => {
    if (
        Object.values(updatedFiltered).length === configAttributesCSR.length - 1
        || Object.values(updatedFiltered).length === configAttributesCSR.length
    ) {
        let removalObject: { [x: number]: any; } | null = null
        configVariants.forEach((variant) => {
            if (variant.flats[0].status === 0 || variant.qty[0] === 0) {
                const filterOnlyInt = variant.product_attribute_values.filter((prAttr: {integer_value: string, attribute_id: number}) =>
                    prAttr.integer_value && configAttributesCSR.some(iii => iii?.attributes_values[0]?.id === prAttr?.attribute_id))
                const filterInActiveVariantAttr1 = filterOnlyInt.filter((prAttr: {integer_value: string, attribute_id: number}) => {
                    return String(updatedFiltered[prAttr.attribute_id]) !== String(prAttr.integer_value)
                })
                if (filterInActiveVariantAttr1.length === 1) {
                    removalObject = {
                        ...removalObject,
                        [filterInActiveVariantAttr1[0].attribute_id]: filterInActiveVariantAttr1[0].integer_value
                    }
                }
                if (removalObject) {
                    setConfigAttributesCSR((prevState) => {
                        return prevState.map((confAttr) => {
                            return {
                                ...confAttr,
                                attribute_options: confAttr?.attribute_options?.map((attrOption) => {
                                    if (removalObject?.[confAttr?.attributes_values?.[0]?.id] !== String(attrOption.id)) {
                                        return attrOption
                                    } else {
                                        return {...attrOption, disabled: true}
                                    }
                                }),
                                attributes_values: [{
                                    ...confAttr?.attributes_values[0],
                                    attribute_options: confAttr?.attributes_values[0]?.attribute_options.map((attrOption) => {
                                        if (removalObject?.[confAttr?.attributes_values?.[0]?.id] !== String(attrOption.id)) {
                                            return attrOption
                                        } else {
                                            return {...attrOption, disabled: true}
                                        }
                                    })
                                }]
                            }
                        })
                    })
                } else {
                    setConfigAttributesCSR(configAttributes);
                }
            }
        })
    }
}

export const configNotExistVariantHelper = (
    {
        setConfigAttributesCSR,
        configAttributesCSR,
        variantProductIsSelected,
        seperatedAttrs,
        filtered
    }: {
        setConfigAttributesCSR: Dispatch<SetStateAction<IAttributeInner[]>>
        configAttributesCSR: IAttributeInner[],
        variantProductIsSelected: boolean,
        seperatedAttrs: Record<string, Record<string, string | number>>[],
        filtered: Record<string, string | number>
    }
) => {
    const filteredValArr = Object.entries(seperatedAttrs).filter((elem) => {
        return Object.entries(filtered).every((eachFilElem) => {
            return String(elem[1][eachFilElem[0]]) === String(eachFilElem[1])
        })
    })
    const removalObject: Record<string, Record<string, string | number>>[] = Object.values(Object.assign(Object.fromEntries(filteredValArr)));
    const optionToggle =  (attrOption: {
        id: number;
        attribute_id: number;
        swatch_value: string;
        translations: Array<{ locale: string; label: string; name: string }>;
        colorsStyle: string;
        sort_order: number
    }) => {
        const findDisabledOption = removalObject.some((elem) => {
            const selectedVariantFiltersOpen = Object.entries(filtered).some((eachFil, _, array) => {
                const filteredArr = array.filter(asd => String(asd[0]) !== String(eachFil[0]));
                return Object.values(seperatedAttrs).filter((elem) => {
                    return filteredArr.every((asd) => {
                        return String(elem[asd[0]]) === String(asd[1])
                    })
                }).map(oji => {
                    const uppOji = Object.entries(oji).filter(asd => {
                        return !filteredArr.some(fil => fil[0] === asd[0])
                    })
                    return Object.fromEntries(uppOji)
                }).some((elem) => String(elem[attrOption.attribute_id]) === String(attrOption.id))
            })
            if (Object.values(filtered).length === configAttributesCSR.length || variantProductIsSelected) {
                return selectedVariantFiltersOpen
            }
            if (
                filtered.hasOwnProperty(attrOption.attribute_id)
                && Object.values(filtered).length !== configAttributesCSR.length - 1
            ) {
                return true
            }
            return String(elem[attrOption.attribute_id]) === String(attrOption.id)
        })
        return {...attrOption, disabled: !findDisabledOption}
    }
    setConfigAttributesCSR((prevState) => {
        return prevState.map((confAttr) => {
            return {
                ...confAttr,
                attribute_options: confAttr?.attribute_options?.map(optionToggle),
                attributes_values: [{
                    ...confAttr?.attributes_values[0],
                    attribute_options: confAttr?.attributes_values[0]?.attribute_options.map(optionToggle)
                }]
            }
        })
    })
}
